// extracted by mini-css-extract-plugin
export var fullHeightState = "_1a-7";
export var headerCell = "_1a-1";
export var loadingStateCell = "_1a-4";
export var rowWrapper = "_1a-3";
export var standaloneTable = "_1a-8";
export var standaloneTableWithBodyFill = "_1a-9";
export var stateCell = "_1a-5";
export var table = "_1a-0";
export var tableBodyFiller = "_1a-6";
export var white = "_1a-2";